import styles from './DeleteModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput } from 'src/components/text-input/TextInput';
import { useCallback, useState } from 'react';
import Spinner from '@src/components/spinner/Spinner';
import WarningIcon from '@src/assets/icons/warning-red.svg?react';

type Props = {
  open: boolean;
  deleting: boolean;
  onClose: () => void;
  onDeleteAccount: () => void;
};

function DeleteModal(props: Props) {
  const { open, deleting, onClose, onDeleteAccount } = props;
  const [ typedelete, setTypeDelete ] = useState("")

  const handleDelete = useCallback(() => {
    if (typedelete === 'DELETE') {
      onDeleteAccount();  
    }
  }, [typedelete, onDeleteAccount]);

  return (
    <Modal open={open} onClose={onClose} className={styles.wrapper}>
      <WarningIcon />
      <div className={styles.content}>
        <div className={styles.subTitle}>{'You cannot undo this action. Please type DELETE in the input box below if you want to delete this account.'}</div>
        <TextInput hasError={false}  id={'delete'} placeholder={'Type DELETE'} value={typedelete} label={''} onChange={(value) => {setTypeDelete(value as string)}} />
        <div className={styles.action}>
          <Button disabled={ typedelete !== 'DELETE' || deleting} leftIcon={deleting ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleDelete} label={'Delete Account'} size="small"/>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
